var map = {
	"./1.png": 19633,
	"./10.png": 87082,
	"./2.png": 76568,
	"./3.png": 44439,
	"./4.png": 92532,
	"./5.png": 31436,
	"./6.png": 32048,
	"./7.png": 23702,
	"./8.png": 96622,
	"./9.png": 11304,
	"./anchor_icon.png": 52578,
	"./author_icon.png": 1189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15995;